module.exports = __webpack_public_path__ + "static/img/科幻.542200d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/AboutUs/科幻.jpg
// module id = X2Br
// module chunks = 12